var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVisibilityOffPassword(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 18.205,
    viewBox: "0 0 20 18.205",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "visibility_off_FILL1_wght400_GRAD0_opsz48",
    d: "M57.636-846.8l-3.818-3.75a8.832,8.832,0,0,1-1.8.489,12.015,12.015,0,0,1-2.023.17,10.42,10.42,0,0,1-6.023-1.852A10.856,10.856,0,0,1,40-856.7a10.312,10.312,0,0,1,1.261-2.307,12.919,12.919,0,0,1,1.966-2.148l-2.864-2.864.955-.977,17.2,17.2ZM50-852.841a4.427,4.427,0,0,0,.682-.057,2.381,2.381,0,0,0,.614-.17L46.364-858a2.782,2.782,0,0,0-.17.614,4.14,4.14,0,0,0-.057.682,3.7,3.7,0,0,0,1.136,2.75A3.758,3.758,0,0,0,50-852.841Zm6.318.909-2.932-2.932a3,3,0,0,0,.352-.852,3.975,3.975,0,0,0,.125-.989,3.727,3.727,0,0,0-1.125-2.739A3.727,3.727,0,0,0,50-860.568a4.2,4.2,0,0,0-.977.114,2.748,2.748,0,0,0-.864.364l-2.5-2.523a10.31,10.31,0,0,1,2.034-.636,11.238,11.238,0,0,1,2.42-.273,10.26,10.26,0,0,1,5.943,1.852A10.74,10.74,0,0,1,60-856.7a11.226,11.226,0,0,1-1.523,2.659A10.977,10.977,0,0,1,56.318-851.932Zm-3.932-3.932-3.227-3.227a2.387,2.387,0,0,1,1.364-.1,2.479,2.479,0,0,1,1.227.648,2.865,2.865,0,0,1,.727,1.17A2.4,2.4,0,0,1,52.386-855.864Z",
    transform: "translate(-40 865)",
    fill: "#22638d",
    opacity: 0.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisibilityOffPassword);
export default __webpack_public_path__ + "static/media/visibilityOffPassword.6dd4039d20436d4e5e8890e83df6a6cc.svg";
export { ForwardRef as ReactComponent };